"use client";

import React from "react";

interface AboutEventProps {
  data: {
    about_the_event: {
      type: string;
      format?: string;
      children: {
        type: string;
        children?: {
          text: string;
          bold?: boolean;
        }[];
        text: string;
      }[];
    }[];
  };
}

const AboutEvent: React.FC<AboutEventProps> = ({ data }) => {
  const aboutList = data?.about_the_event || [];
  const paragraphItems = aboutList.filter((item) => item.type === "paragraph");
  const listItems = aboutList.filter((item) => item.type === "list");

  return (
    <div className="w-full bg-[#fff]">
      <div className="main_container mx-auto md:px-5 md:py-12 py-4 flex flex-col gap-8 px-4">
        <div className="items-center w-full md:px-2 mt-16 mb-4 md:mt-16">
          <h2 className="text-[28px] md:text-[32px] lg:text-[36px] font-semibold tracking-[-1.76px] text-[#000000] font-sans leading-[1.2]">
            About the event
          </h2>

          <div className="w-full pt-6 flex flex-col space-y-6">
            {paragraphItems.length > 0 && (
              <div className="">
                {paragraphItems?.map((item, index) => (
                  <div key={index} className="flex gap-3 items-start">
                    <p className="text-[#000000] text-sm md:text-base font-normal leading-relaxed">
                      {item.children?.map((childItem, i) =>
                        childItem.children ? (
                          childItem.children?.map((subChild, j) => (
                            <React.Fragment key={j}>
                              {subChild.bold ? (
                                <strong className="text-[#000000]">
                                  {subChild.text}
                                </strong>
                              ) : (
                                subChild.text
                              )}
                            </React.Fragment>
                          ))
                        ) : (
                          <React.Fragment key={i}>
                            {childItem.text}{" "}
                          </React.Fragment>
                        ),
                      )}
                    </p>
                  </div>
                ))}
              </div>
            )}

            {listItems.length > 0 &&
              listItems?.map((item, index) => (
                <ul key={index} className="space-y-3">
                  {item.children?.map((childItem, i) => (
                    <li key={i} className="flex items-start gap-3">
                      <p className="text-[#A8A8A8] text-sm md:text-base font-normal">
                        {childItem.children?.map((child, j) => (
                          <span
                            key={j}
                            className={
                              child.bold ? "font-bold text-[#fff]" : ""
                            }
                          >
                            {child.text}
                          </span>
                        ))}
                      </p>
                    </li>
                  ))}
                </ul>
              ))}

            {aboutList.length === 0 && (
              <p className="text-[#A8A8A8] text-sm md:text-base font-normal">
                No information available about the event.
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutEvent;
